import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { queryBrandListApi } from '@eastcoal/api/content/brandMall/queryBrandList'

import { AutoScroll } from '@eastcoal/common/components/AutoScroll'

import { PagePosition } from '@eastcoal/shared/enums/PagePosition'

import { BrandGalleryProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    gap: token.paddingXS
  },
  img: {
    height: 48
  }
}))

export const BrandGallery = ({
  pageName,
  classNames: externalClassNames,
  styles: externalStyles
}: BrandGalleryProps) => {
  const { data } = useRequest(
    () =>
      queryBrandListApi(
        { pageName, pagePosition: PagePosition.BOTTOM },
        { silence: true }
      ),
    {
      manual: false,
      retryCount: 3,
      retryInterval: 200
    }
  )

  const { cx, styles } = useStyles()

  return (
    <div
      className={externalClassNames?.rootWrapper}
      style={externalStyles?.rootWrapper}
    >
      <AutoScroll
        orientation='horizontal'
        styles={{ scroller: externalStyles?.container }}
        classNames={{
          scroller: cx(styles.container, externalClassNames?.container)
        }}
      >
        {data
          ?.filter(item => !!item.accessUrl)
          .map(({ id, accessUrl, navigateUrl }) => (
            <a key={id} href={navigateUrl} rel='noreferrer' target='_blank'>
              <img
                alt='banner'
                className={cx(styles.img, externalClassNames?.img)}
                src={accessUrl}
                style={externalStyles?.img}
              />
            </a>
          ))}
      </AutoScroll>
    </div>
  )
}
